<div class="modal-header">
    <h4>{{headerText}}</h4>
    <button class="btn btn-outline-dark" type="button" (click)="previewCompleteTrip()" [disabled]="closeCount == 0">Preview</button>
</div>
<div class="modal-body">
    <div class="alert alert-danger" *ngIf="stopCompleteTrip && !isCollectSignature">
        You are currently clocked-in to a scope on this work order - please clock out before completing the trip.
    </div>
    <div class="alert alert-primary" *ngIf="!stopCompleteTrip && !isCollectSignature">
        This will complete the current trip.
    </div>

    <div class="alert alert-danger" *ngIf="closeOutMissCompleteForm && !isCollectSignature" style="display:block;">
        <div>
            {{alertForm}}
        </div>
        <div>
            <ul>
                <li *ngFor="let data of missingRequireForm">Scope {{data.ScopeSeq}} - {{data.ChecklistTemplateName}}</li>
            </ul>
        </div>
    </div>

    <div class="alert alert-danger" *ngIf="closeOutMissingCallType && !isCollectSignature" style="display:block;">
        {{alertCall}} Scope {{missingCallType}}
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:10px;" *ngIf="!stopCompleteTrip" [disabled]="SMHideAttachmentOnComplete">
        <input id="bypassAttachCheckBox" type="checkbox" style="width:25px;height:25px;display:flex;" [(ngModel)]="formData.bypassAttach" (click)="hideAttachmentChange()">
        <span style="display:flex;margin-top:-25px;margin-left:30px;">Hide Attachments During Completion</span>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:10px;" *ngIf="!stopCompleteTrip">
        <input id="loadAttachCheckBox" type="checkbox" style="width:25px;height:25px;display:flex;" [(ngModel)]="formData.loadAttachData" [disabled]="formData.bypassAttach">
        <span style="display:flex;margin-top:-25px;margin-left:30px;">Include Photo Thumbnails During Review</span>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:10px;" *ngIf="!stopCompleteTrip && SMEnablePaymentCollection && !isCollectSignature">
        <input id="paymentCheckBox" type="checkbox" style="width:25px;height:25px;display:flex;" [(ngModel)]="formData.collectPayment">
        <span style="display:flex;margin-top:-25px;margin-left:30px;">Collect Payment Onsite</span>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="margin-bottom:10px;" *ngIf="!stopCompleteTrip && !SMHideReturnTrip && !isCollectSignature">
        <input id="closeOutCheckBox" type="checkbox" style="width:25px;height:25px;display:flex;" [(ngModel)]="formData.closeReturnTripRequired" (click)="closeRequireUpdate()">
        <span style="display:flex;margin-top:-25px;margin-left:30px;">Return Trip Required</span>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="!stopCompleteTrip && !SMHideReturnTrip && !isCollectSignature">
        <label>Return trip reason:</label>
        <ng-select [ngClass]="{'is-invalid': formData.closeReturnTripRequired && formData.closeReturnTripReason == null}" style="max-width:300px;"
                [(ngModel)]="formData.closeReturnTripReason" [required]="formData.closeReturnTripRequired" [disabled]="!formData.closeReturnTripRequired"
                [items]="lookup['SMReturnTripReasons']"
                bindValue="Code"
                bindLabel="CodeDescription"></ng-select>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="!stopCompleteTrip && !SMHideReturnTrip && !isCollectSignature">
        <label>Notes:</label>
        <textarea [(ngModel)]="formData.closeNotes" class="form-control" appElastic rows="3" placeholder="Enter notes about your work here..." [disabled]="!formData.closeReturnTripRequired"
                  [ngClass]="{'is-invalid': formData.closeReturnTripRequired && RequiredTripNotes && (formData.closeNotes == null || formData.closeNotes === '')}" style="font-size:14px;overflow-y: hidden;"
                  [required]="formData.closeReturnTripRequired && RequiredTripNotes && (formData.closeNotes == null || formData.closeNotes === '')"></textarea>
    </div>
    <hr />
    <div class="row" style="margin-left: 10px;margin-bottom: 10px;" *ngIf="!stopCompleteTrip">
        Completed Scopes for Customer Signature:
    </div>
    <div class="row" *ngIf="!stopCompleteTrip && smDataService.currentOnline">
        <table class="table">
            <thead>
                <tr>
                    <th>
                        <input type="checkbox" (change)="checkAll()" [(ngModel)]="formData.allCheck" style="width: 25px; height: 25px; vertical-align: middle;" />
                        {{isCollectSignature ? "Sign" : "Complete"}}
                    </th>
                    <th>Seq</th>
                    <th>Scope</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of currentTrip.ScopeData">
                    <td><input type="checkbox" [(ngModel)]="data.IsClose" style="width:25px;height:25px;" (change)="updateCheck(data.IsClose)" /></td>
                    <td>{{data.Scope}}</td>
                    <td>{{data.ScopeDescription}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="continueClicked()" *ngIf="!stopCompleteTrip"
            [disabled]="(closeCount == 0 && !formData.closeReturnTripRequired) || (formData.closeReturnTripRequired && (formData.closeReturnTripReason == null || (RequiredTripNotes && (formData.closeNotes == null || formData.closeNotes === ''))))">
        Continue
    </button>
</div>